import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

// `customer` (contact/company/invoices/subscriptions) is written on login
// but has no reader anywhere - CustomerPortalAuth.jsx passes the same data
// to its onAuthSuccess callback instead. Not removed here (a real writer
// exists, just no current reader - different from a genuinely dead field),
// see docs/known-issues.md.
const initialState = {
  isAuthenticated: false,
  token: null,
  customer: {
    contact: null,
    company: null,
    invoices: [],
    subscriptions: [],
  },
};

const customerPortalSlice = createSlice({
  name: "customerPortal",
  initialState,
  reducers: {
    setCustomerAuth: (state, action) => {
      const { token, customer, isAuthenticated } = action.payload;
      state.isAuthenticated = isAuthenticated;
      state.token = token;
      state.customer = customer;
    },
    logoutCustomer: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.customer = {
        contact: null,
        company: null,
        invoices: [],
        subscriptions: [],
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.customerPortal) {
        return {
          ...state,
          ...action.payload.customerPortal,
        };
      }
      return state;
    });
  },
});

export const { setCustomerAuth, logoutCustomer } = customerPortalSlice.actions;
export default customerPortalSlice.reducer;
